
export default [
  {
    path: "/FactoryInfoMaintain",
    name: "PageFactoryInfoMaintain",
    component: () => import(`@/views/PageFactoryInfoMaintain.vue`),
    props: true,
  },
  {
    path: "/CartypeMaintainForm",
    name: "PageFactoryInfoMaintainCartypeMaintainForm",
    component: () => import(`@/views/PageCartypeMaintainForm.vue`),
    props: true,
  },
  {
    path: "/CartypeMaintainInfo",
    name: "PageFactoryInfoMaintainCartypeMaintainInfo",
    component: () => import(`@/views/PageCartypeMaintainInfo.vue`),
    props: true,
  },
  {
    path: "/LocationMaintainForm",
    name: "PageFactoryInfoMaintainLocationMaintainForm",
    component: () => import(`@/views/PageLocationMaintainForm.vue`)
  },
  {
    path: "/LocationMaintainInfo",
    name: "PageFactoryInfoMaintainLocationMaintainInfo",
    component: () => import(`@/views/PageLocationMaintainInfo.vue`),
    props: true,
  },
  {
    path: "/VendorInfoMaintain",
    name: "PageVendorInfoMaintain",
    component: () => import(`@/views/PageVendorInfoMaintain.vue`),
    props: true,
  },
  {
    path: "/VendorInfoMaintainForm",
    name: "PageVendorInfoMaintainForm",
    component: () => import(`@/views/PageVendorInfoMaintainForm.vue`),
  },
  {
    path: "/VendorInfoMaintainInfo",
    name: "PageVendorInfoMaintainInfo",
    component: () => import(`@/views/PageVendorInfoMaintainInfo.vue`),
    props: true,
  },
  {
    path: "/VendorPasswordMaintain",
    name: "PageVendorPasswordMaintain",
    component: () => import(`@/views/PageVendorPasswordMaintain.vue`),
  },
  {
    path: "/AuthorityMaintain",
    name: "PageAuthorityMaintain",
    component: () => import(`@/views/PageAuthorityMaintain.vue`),
    props: true,
  },
  {
    path: "/AuthorityMaintainForm",
    name: "PageAuthorityMaintainForm",
    component: () => import(`@/views/PageAuthorityMaintainForm.vue`),
  },
  {
    path: "/AuthorityMaintainInfo",
    name: "PageAuthorityMaintainInfo",
    component: () => import(`@/views/PageAuthorityMaintainInfo.vue`),
    props: true,
  },
  {
    path: "/PageJITMaintain",
    name: "PageJITMaintain",
    component: () => import(`@/views/PageJITMaintain.vue`),
  },
  {
    path: "/PageGuardShiftMaintain",
    name: "PageGuardShiftMaintain",
    component: () => import(`@/views/guardShift/PageGuardShiftMaintain.vue`),
  }

]